import React, { useEffect, useState } from "react";
import { FlexContainer, MedCol50 } from "../common/Flex";
import { ControlBox, ControlBoxHeader, ControlBoxLabel } from "../common/ControlBox";
import CheckboxOption from "./CheckboxOption";
import styled from "styled-components";
import api from '../../utils/api';

interface Jargon {
  id: number;
  name: string;
  description: string;
}

interface JargonControlBoxProps {
  onChange: (id: number, checked:boolean) => void;
  selectedJargons: number[];
  onLoaded: () => void;
}

const JargonGrid = styled.div`
  columns: 2;
  column-gap: 40px;
  margin-top: 30px;
`;

const JargonControlBox: React.FC<JargonControlBoxProps> = ({ selectedJargons, onChange, onLoaded }) => {
  const [jargons, setJargons] = useState<Jargon[]>([]);

  useEffect(() => {
    const fetchJargons = async () => {
      try {
        const response = await api.get("jargons");
        setJargons(response.data);
        onLoaded();
      } catch (err) {
        console.error("Failed to load styles", err);
      }
    };

    fetchJargons();
  }, [onLoaded]);

  useEffect(() => {
    if (jargons.length > 0 && selectedJargons.length === 0) {
      onChange(jargons[0].id, true);
    }
  }, [jargons, selectedJargons, onChange]);

  const allJargonsSelected = jargons.length > 0 && selectedJargons.length === jargons.length;

  const handleEverythingIpsum = (checked: boolean) => {
    if (checked) {
      // Check all jargons
      jargons.forEach(jargon => {
        if (!selectedJargons.includes(jargon.id)) {
          onChange(jargon.id, true);
        }
      });
    } else {
      // Uncheck all except the first
      jargons.forEach((jargon, index) => {
        if (index === 0) {
          if (!selectedJargons.includes(jargon.id)) {
            onChange(jargon.id, true);
          }
        } else {
          if (selectedJargons.includes(jargon.id)) {
            onChange(jargon.id, false);
          }
        }
      });
    }
  };

  return (
    <ControlBox scaleLarge={2} scaleMedium={2}>
        <ControlBoxHeader>
            <ControlBoxLabel>1.</ControlBoxLabel>
            Jargon Mix-ins
        </ControlBoxHeader>
        <p>These are the word banks we pepper into our traditional lorem ipsum generator to provide your industry placeholder text.</p>
        <p>Want to be a know-it-all generalist? Try Everything Ipsum!</p>

      <JargonGrid>
          {jargons.map(jargon => (
            <CheckboxOption
              key={jargon.id}
              id={`jargon-${jargon.id}`}
              checked={selectedJargons.includes(jargon.id)}
              onChange={e => onChange(jargon.id, e.target.checked)}
            >
              {jargon.name}
            </CheckboxOption>
          ))}
          <CheckboxOption
            key="everything-ipsum"
            id="everything-ipsum"
            checked={allJargonsSelected}
            onChange={e => handleEverythingIpsum(e.target.checked)}
          >
            Everything Ipsum<sup>TM</sup>
          </CheckboxOption>
      </JargonGrid>
    </ControlBox>
  );
};

export default JargonControlBox;